import { useRender } from "@base-ui/react/use-render";
import * as React from "react";

export type SlotProps = React.HTMLAttributes<HTMLElement> & {
  children?: React.ReactNode;
  ref?: React.Ref<HTMLElement>;
};

/**
 * Merges its props onto its single child element, the way Radix's `Slot` did.
 */
export function Slot({ children, ref, ...props }: SlotProps) {
  return useRender({
    render: React.Children.only(children) as React.ReactElement,
    props,
    ref,
  });
}
